export default "__VITE_ASSET__9786200d__"